<script>
  import { format } from 'svelte-i18n';

  import { AUDIT_HISTORY_ACTIONS } from '@client/enums';

  export let row = {};

  $: action = row.action;
</script>

<div class="badge-{action}">
  {$format(AUDIT_HISTORY_ACTIONS[action]?.label || action)}
</div>

<style lang="scss">
  [class*='badge-'] {
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-base);
    display: inline-block;
    font-size: var(--font-size-xsmall);
    font-weight: var(--font-weight-medium);
    padding: var(--padding-small) var(--padding-base);
    text-transform: uppercase;
    white-space: nowrap;

    &.badge-create {
      border-color: var(--color-blue-300);
      color: var(--color-blue-400);
    }

    &.badge-custompurge,
    &.badge-delete {
      border-color: var(--color-red-300);
      color: var(--color-red-400);
    }

    &.badge-editfrontapp,
    &.badge-editgoogle,
    &.badge-editoutreach,
    &.badge-pusho365,
    &.badge-pushemail,
    &.badge-pushfrontapp,
    &.badge-pushgoogle,
    &.badge-pushoutreach,
    &.badge-pushsalesforce {
      border-color: var(--color-yellow-300);
      color: var(--color-yellow-400);
    }

    &.badge-login {
      border-color: var(--color-gray-600);
      color: var(--color-gray-700);
    }

    &.badge-update {
      border-color: var(--color-green-300);
      color: var(--color-green-400);
    }

    &.badge-syncbamboohrusers,
    &.badge-synccalendlyusers,
    &.badge-syncfrontappusers,
    &.badge-synco365groups,
    &.badge-synco365users,
    &.badge-syncgappsgroups,
    &.badge-syncgappsorgs,
    &.badge-syncgappsusers,
    &.badge-syncmangoappsusers,
    &.badge-syncsalesforceusers,
    &.badge-updateuser,
    &.badge-synccsvusers {
      border-color: var(--color-green-200);
      color: var(--color-green-300);
    }
  }
</style>
